/// <reference path="../types/index.d.ts" />

import '../client_forms/chris2/style.css';
import FormStructure from './chris2/form_structure';

export default FormStructure;